function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.894,7.218c.887.381,1.508,1.262,1.508,2.288,0,1.374-1.114,2.489-2.488,2.489-.615,0-1.178-.223-1.613-.594.276.118.571.186.872.198,1.373.06,2.535-1.005,2.595-2.378.034-.796-.31-1.522-.874-2.003h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12.521,9.048l.282-.868-.738.536h.912l-.738-.536.282.868Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M12.521,7.768l.282-.868-.738.536h.912l-.738-.536.282.868Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M13.785,8.424l.282-.868-.738.536h.912l-.738-.536.282.868Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M11.256,9.672l.282-.868-.738.536h.912l-.738-.536.282.868Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M12.521,10.328l.282-.868-.738.536h.912l-.738-.536.282.868Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,5h5.4v20H3.6V5Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.72 5.104 3.847 5.104 3.948 5.001 3.6 5.001 3.6 5.369 3.72 5.247 3.72 5.104",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.732 5.001 4.401 5.304 4.269 5.18 4.391 5.18 4.368 5.041 4.156 5.041 3.738 5.433 3.738 5.583 3.923 5.583 3.923 5.458 4.018 5.544 3.801 5.745 3.903 5.842 3.6 6.125 3.6 6.321 4.114 5.843 4.012 5.746 4.227 5.545 4.042 5.372 4.166 5.259 4.403 5.478 4.922 5.001 4.921 5.001 4.732 5.001",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.578 5.001 4.459 5.001 4.476 5.096 4.578 5.001",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.706 5.088 3.842 5.088 3.929 5.001 3.6 5.001 3.6 5.348 3.706 5.242 3.706 5.088",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.753 5.001 4.401 5.323 4.232 5.166 4.373 5.166 4.354 5.055 4.163 5.055 3.752 5.438 3.752 5.569 3.909 5.569 3.909 5.422 4.04 5.544 3.823 5.745 3.925 5.842 3.6 6.144 3.6 6.299 4.093 5.842 3.991 5.745 4.206 5.544 4.021 5.371 4.166 5.237 4.403 5.458 4.899 5.001 4.898 5.001 4.753 5.001",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.556 5.001 4.475 5.001 4.486 5.065 4.556 5.001",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,7.32v.196l.304.284-.102.095.217.201-.095.086v-.125h-.186v.15l.418.392h.212l.023-.138h-.122l.132-.124.332.302-.332.304-.132-.124h.122l-.023-.139h-.212l-.418.392v.15h.185v-.125l.095.086-.217.201.102.097-.303.284v.196l.514-.478-.102-.097.215-.201-.185-.173.124-.113.237.219.519-.477-.519-.477-.237.221-.124-.115.185-.173-.215-.201.102-.095-.514-.481ZM3.6,8.272v.738l.12-.122v-.143h.127l.102-.104-.102-.102h-.127v-.145l-.12-.122ZM4.476,8.533l-.018.101.018.102.109-.102-.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,7.341v.155l.325.304-.102.095.217.201-.131.122v-.147h-.157v.131l.411.383h.191l.019-.109h-.141l.169-.159.353.323-.353.323-.169-.157h.141l-.019-.111h-.191l-.411.383v.131h.157v-.147l.131.122-.217.201.102.097-.325.303v.155l.493-.457-.102-.097.215-.201-.185-.173.145-.134.237.221.496-.457-.496-.457-.237.221-.146-.136.185-.173-.215-.201.102-.095-.492-.46h0ZM3.6,8.293v.696l.106-.106v-.154h.136l.088-.088-.088-.088h-.136v-.154l-.106-.106h0ZM4.486,8.561l-.012.072.012.072.078-.072-.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,11.08v.196l.304.284-.102.095.217.201-.095.087v-.125h-.186v.15l.418.392h.212l.023-.138h-.122l.132-.124.332.302-.332.304-.132-.124h.122l-.023-.139h-.212l-.418.392v.15h.185v-.125l.095.086-.217.201.102.097-.303.283v.196l.514-.478-.102-.097.215-.201-.185-.173.124-.113.237.219.519-.477-.519-.477-.237.221-.124-.115.185-.173-.215-.201.102-.095-.514-.481ZM3.6,12.031v.738l.12-.122v-.143h.127l.102-.104-.102-.102h-.127v-.145l-.12-.122ZM4.476,12.293l-.018.101.018.102.109-.102-.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,11.101v.155l.325.304-.102.095.217.201-.131.122v-.146h-.157v.131l.411.383h.191l.019-.109h-.141l.169-.159.353.323-.353.323-.169-.157h.141l-.019-.111h-.191l-.411.383v.131h.157v-.147l.131.122-.217.201.102.097-.325.302v.155l.493-.457-.102-.097.215-.201-.185-.173.145-.134.237.221.496-.457-.496-.457-.237.221-.146-.136.185-.173-.215-.201.102-.095-.492-.46h0ZM3.6,12.053v.696l.106-.106v-.154h.136l.088-.088-.088-.088h-.136v-.154l-.106-.106h0ZM4.486,12.321l-.012.072.012.072.078-.072-.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,14.84v.196l.304.284-.102.095.217.201-.095.086v-.125h-.186v.15l.418.392h.212l.023-.138h-.122l.132-.124.332.302-.332.304-.132-.123h.122l-.023-.139h-.212l-.418.392v.15h.185v-.125l.095.086-.217.201.102.097-.303.283v.196l.514-.478-.102-.097.215-.201-.185-.173.124-.113.237.219.519-.477-.519-.477-.237.221-.124-.115.185-.173-.215-.201.102-.095-.514-.481ZM3.6,15.791v.738l.12-.122v-.143h.127l.102-.104-.102-.102h-.127v-.145l-.12-.122ZM4.476,16.053l-.018.101.018.102.109-.102-.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,14.861v.155l.325.304-.102.095.217.201-.131.122v-.147h-.157v.131l.411.383h.191l.019-.109h-.141l.169-.159.353.323-.353.323-.169-.157h.141l-.019-.111h-.191l-.411.383v.131h.157v-.146l.131.122-.217.201.102.097-.325.301v.155l.493-.457-.102-.097.215-.201-.185-.173.145-.134.237.221.496-.457-.496-.457-.237.221-.146-.135.185-.173-.215-.201.102-.095-.492-.46h0ZM3.6,15.813v.696l.106-.106v-.154h.136l.088-.088-.088-.088h-.136v-.154l-.106-.106h0ZM4.486,16.081l-.012.072.012.072.078-.072-.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,18.6v.196l.304.284-.102.095.217.201-.095.087v-.125h-.186v.15l.418.392h.212l.023-.138h-.122l.132-.124.332.302-.332.304-.132-.124h.122l-.023-.139h-.212l-.418.392v.15h.185v-.125l.095.086-.217.201.102.097-.303.283v.196l.514-.478-.102-.097.215-.201-.185-.173.124-.113.237.219.519-.477-.519-.477-.237.221-.124-.115.185-.173-.215-.201.102-.095-.514-.481ZM3.6,19.551v.738l.12-.122v-.143h.127l.102-.104-.102-.102h-.127v-.145l-.12-.122ZM4.476,19.813l-.018.101.018.102.109-.102-.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,18.621v.155l.325.304-.102.095.217.201-.131.122v-.146h-.157v.131l.411.383h.191l.019-.109h-.141l.169-.159.353.323-.353.323-.169-.157h.141l-.019-.111h-.191l-.411.383v.131h.157v-.147l.131.122-.217.201.102.097-.325.301v.155l.493-.457-.102-.097.215-.201-.185-.173.145-.134.237.221.496-.457-.496-.457-.237.221-.145-.134.185-.173-.215-.201.102-.095-.493-.461h0ZM3.6,19.572v.696l.106-.106v-.154h.136l.088-.088-.088-.088h-.136v-.154l-.106-.106h0ZM4.486,19.841l-.012.072.012.072.078-.072-.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.651 5.001 8.753 5.104 8.88 5.104 8.88 5.247 9 5.369 9 5.001 8.651 5.001",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.141 5.001 8.022 5.001 8.124 5.096 8.141 5.001",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.799 5.745 8.582 5.544 8.677 5.458 8.677 5.583 8.862 5.583 8.862 5.433 8.444 5.041 8.232 5.041 8.209 5.18 8.331 5.18 8.199 5.304 7.868 5.001 7.679 5.001 7.678 5.001 8.197 5.478 8.434 5.259 8.558 5.372 8.373 5.545 8.588 5.746 8.486 5.843 9 6.321 9 6.125 8.697 5.842 8.799 5.745",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.125 5.001 8.044 5.001 8.114 5.065 8.125 5.001",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.777 5.745 8.56 5.544 8.691 5.422 8.691 5.569 8.848 5.569 8.848 5.438 8.437 5.055 8.246 5.055 8.227 5.166 8.368 5.166 8.199 5.323 7.847 5.001 7.702 5.001 7.701 5.001 8.197 5.458 8.434 5.237 8.579 5.371 8.394 5.544 8.609 5.745 8.507 5.842 9 6.299 9 6.144 8.675 5.842 8.777 5.745",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.671 5.001 8.758 5.088 8.894 5.088 8.894 5.242 9 5.348 9 5.001 8.671 5.001",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,7.32v.196l-.304.284.102.095-.217.201.095.086v-.125h.185v.15l-.418.392h-.211l-.023-.138h.122l-.132-.124-.332.302.332.304.132-.124h-.122l.023-.139h.212l.418.392v.15h-.185v-.125l-.095.086.217.201-.102.097.303.284v.196l-.514-.478.102-.097-.215-.201.185-.173-.124-.113-.237.219-.519-.477.519-.477.237.221.124-.115-.185-.173.215-.201-.102-.095.514-.481ZM9,8.272v.738l-.12-.122v-.143h-.127l-.102-.104.102-.102h.127v-.145l.12-.122ZM8.124,8.533l.018.101-.018.102-.109-.102.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,7.341v.155l-.325.304.102.095-.217.201.131.122v-.147h.157v.131l-.411.383h-.191l-.019-.109h.141l-.169-.159-.353.323.353.323.169-.157h-.141l.019-.111h.191l.411.383v.131h-.157v-.147l-.131.122.217.201-.102.097.325.303v.155l-.493-.457.102-.097-.215-.201.185-.173-.145-.134-.237.221-.496-.457.496-.457.237.221.145-.134-.185-.173.215-.201-.102-.095.493-.462h0ZM9,8.293v.696l-.106-.106v-.154h-.136l-.088-.088.088-.088h.136v-.154l.106-.106h0ZM8.114,8.561l.012.072-.012.072-.078-.072.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11.08v.196l-.304.284.102.095-.217.201.095.087v-.125h.185v.15l-.418.392h-.211l-.023-.138h.122l-.132-.124-.332.302.332.304.132-.124h-.122l.023-.139h.212l.418.392v.15h-.185v-.125l-.095.086.217.201-.102.097.303.283v.196l-.514-.478.102-.097-.215-.201.185-.173-.124-.113-.237.219-.519-.477.519-.477.237.221.124-.115-.185-.173.215-.201-.102-.095.514-.481ZM9,12.031v.738l-.12-.122v-.143h-.127l-.103-.104.102-.102h.128v-.145l.12-.122ZM8.124,12.293l.018.101-.018.102-.109-.102.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11.101v.155l-.325.304.102.095-.217.201.131.122v-.146h.157v.131l-.411.383h-.191l-.019-.109h.141l-.169-.159-.353.323.353.323.169-.157h-.141l.019-.111h.191l.411.383v.131h-.157v-.147l-.131.122.217.201-.102.097.325.302v.155l-.493-.457.102-.097-.215-.201.185-.173-.145-.134-.237.221-.496-.457.496-.457.237.221.145-.134-.185-.173.215-.201-.102-.095.493-.462h0ZM9,12.053v.696l-.106-.106v-.154h-.136l-.088-.089.088-.088h.136v-.154l.106-.105h0ZM8.114,12.321l.012.072-.012.072-.078-.072.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,14.84v.196l-.304.284.102.095-.217.201.095.086v-.125h.185v.15l-.418.392h-.211l-.023-.138h.122l-.132-.124-.332.302.332.304.132-.123h-.122l.023-.139h.212l.418.392v.15h-.185v-.125l-.095.086.217.201-.102.097.303.283v.196l-.514-.478.102-.097-.215-.201.185-.173-.124-.113-.237.219-.519-.477.519-.477.237.221.124-.115-.185-.173.215-.201-.102-.095.514-.481ZM9,15.791v.738l-.12-.122v-.143h-.127l-.103-.104.102-.102h.128v-.145l.12-.122ZM8.124,16.053l.018.101-.018.102-.109-.102.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,14.861v.155l-.325.304.102.095-.217.201.131.122v-.147h.157v.131l-.411.383h-.191l-.019-.109h.141l-.169-.159-.353.323.353.323.169-.157h-.141l.019-.111h.191l.411.383v.131h-.157v-.146l-.131.122.217.201-.102.097.325.301v.155l-.493-.457.102-.097-.215-.201.185-.173-.145-.134-.237.221-.496-.457.496-.457.237.221.145-.134-.185-.173.215-.201-.102-.095.493-.461h0ZM9,15.813v.696l-.106-.106v-.154h-.136l-.088-.089.088-.088h.136v-.154l.106-.105h0ZM8.114,16.081l.012.072-.012.072-.078-.072.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,18.6v.196l-.304.284.102.095-.217.201.095.087v-.125h.185v.15l-.418.392h-.211l-.023-.138h.122l-.132-.124-.332.302.332.304.132-.124h-.122l.023-.139h.212l.418.392v.15h-.185v-.125l-.095.086.217.201-.102.097.303.283v.196l-.514-.478.102-.097-.215-.201.185-.173-.124-.113-.237.219-.519-.477.519-.477.237.221.124-.115-.185-.173.215-.201-.102-.095.514-.481ZM9,19.551v.738l-.12-.122v-.143h-.127l-.103-.104.102-.102h.128v-.145l.12-.122ZM8.124,19.813l.018.101-.018.102-.109-.102.109-.101Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,18.621v.155l-.325.304.102.095-.217.201.131.122v-.146h.157v.131l-.411.383h-.191l-.019-.109h.141l-.169-.159-.353.323.353.323.169-.157h-.141l.019-.111h.191l.411.383v.131h-.157v-.147l-.131.122.217.201-.102.097.325.301v.155l-.493-.457.102-.097-.215-.201.185-.173-.145-.134-.237.221-.496-.457.496-.457.237.221.145-.134-.185-.173.215-.201-.102-.095.493-.461h0ZM9,19.572v.696l-.106-.106v-.154h-.136l-.088-.088.088-.088h.136v-.154l.106-.106h0ZM8.114,19.841l.012.072-.012.072-.078-.072.078-.072Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.038,22.694c.027.114.117.199.138.317.043-.123.083-.226.053-.36-.021-.096-.102-.165-.111-.263-.088.079-.107.192-.08.306ZM4.016,23.17c.075.102.179.181.293.234-.023-.09.02-.157.067-.229.057-.086.084-.17.038-.269-.022.051-.05.094-.084.138-.05.068-.083.129-.091.217-.058-.043-.084-.107-.115-.17-.047-.089-.124-.164-.212-.212.024.101.042.206.104.291h0ZM4.435,23.476c-.016.057-.03.113-.027.173-.049-.053-.115-.093-.174-.136-.08-.064-.173-.11-.238-.192.01.121.061.219.16.293.104.078.229.119.331.201-.015-.11.025-.198.059-.299.029-.096,0-.194-.064-.268.002.081-.024.151-.047.228h0ZM4.668,23.847c.022.083.081.151.122.225-.11-.034-.207-.094-.306-.15-.118-.064-.247-.105-.354-.191.053.197.186.312.379.37.132.04.244.02.404.085-.018-.109-.051-.226-.102-.324-.04-.071-.084-.141-.109-.219-.036.066-.053.131-.034.204h0ZM5.072,24.149c.037.065.089.12.15.162-.156.01-.282-.089-.434-.093-.094-.003-.183.027-.279.018.114.077.233.144.371.162.18.023.346-.022.545-.004-.093-.065-.139-.153-.197-.247-.075-.118-.146-.202-.293-.221.059.066.093.147.137.223h0ZM5.627,24.408c-.275.047-.539.107-.819.11.314.11.611.129.922.016.168-.061.298-.094.425-.085.186.013.412.087.662.351l.098-.079c-.358-.319-.827-.391-1.288-.313h0Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.276,7.345l-.433-.265v-.638l.433-.265v-.337l.409-.246h.327l.622-.35h1.334l.622.35h.327l.409.246v.337l.433.265v.638l-.433.265v.338l-.409.246h-.328l-.622.35h-1.334l-.622-.35h-.327l-.409-.246v-.338h0Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.636,5.258l-.621.35h-.326l-.399.24v.337l-.433.265v.621l.433.265v.339l.397.24h.327l.621.35h1.328l.621-.35h.327l.399-.24v-.339l.433-.265v-.621l-.433-.265v-.337l-.399-.24h-.326l-.621-.35h-1.328ZM5.673,5.387h1.255l.621.35h.325l.302.182v.337l.434.265v.48l-.434.265v.337l-.302.182h-.325l-.621.35h-1.255l-.621-.35h-.326l-.304-.182v-.337l-.433-.265v-.48l.433-.265v-.337l.304-.182h.325l.622-.35Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293,6.768v-1.367h-.617l-.622.35h-.324l-.293.177v.337l-.433.265v.225h2.303v1.367h.617l.622-.35h.324l.293-.177v-.337l.433-.265v-.224h-2.303Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.004,6.768v.225l.433.265v.337l.293.177h.324l.622.35h.617v-1.367h2.303v-.224l-.433-.265v-.337l-.293-.179h-.325l-.622-.35h-.616v1.367h-2.303Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.948,5.876l-.107-.099-.106.065.107.099-.137.085h.299l.258.243.082-.087-.25-.236v-.16l-.146.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.452,5.833l-.107-.099-.106.065.107.099-.137.085h.299l.258.243.082-.087-.25-.236v-.16l-.146.09ZM4.911,6.162l-.107-.099-.105.065.107.099-.137.085h.299l.258.243.082-.087-.251-.236v-.16l-.146.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,5.387h-.27l-.141.136h-.275l-.203.106.047.116.181-.095h.079l.278.322.303-.185v-.4Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84,5.795l.096.089-.08.05-.096-.089.08-.05ZM5.08,5.811v.141l.245.231-.063.066-.251-.237h-.255l.324-.201h0ZM5.344,5.751l.096.089-.08.05-.096-.089.08-.05ZM5.584,5.768v.141l.245.231-.063.066-.251-.237h-.255l.324-.201h0Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.803,6.08l.096.089-.08.05-.096-.089.08-.05ZM5.043,6.097v.141l.245.231-.063.066-.251-.237h-.255s.324-.201.324-.201ZM6.293,5.401h-.257l-.141.136h-.278l-.189.098.037.089.171-.09h.089l.275.318.293-.179v-.372Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.948,7.645l-.107.099-.106-.065.107-.099-.137-.085h.299l.258-.243.082.087-.25.236v.16l-.146-.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.452,7.689l-.107.099-.106-.065.107-.099-.137-.085h.299l.258-.243.082.087-.25.236v.16l-.146-.09ZM4.911,7.36l-.107.099-.105-.065.107-.099-.137-.085h.299l.258-.243.082.087-.251.236v.16l-.146-.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,8.135h-.27l-.141-.136h-.275l-.203-.106.047-.116.181.095h.079l.278-.322.303.185v.4Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84,7.726l.096-.089-.08-.05-.096.089.08.05ZM5.08,7.71v-.141l.245-.231-.063-.066-.251.237h-.255l.324.201h0ZM5.344,7.77l.096-.089-.08-.05-.096.089.08.05ZM5.584,7.754v-.141l.245-.231-.063-.066-.251.237h-.255l.324.201h0Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.803,7.441l.096-.089-.08-.05-.096.089.08.05ZM5.043,7.425v-.141l.245-.231-.063-.066-.251.237h-.255s.324.201.324.201ZM6.293,8.121h-.257l-.141-.136h-.278l-.189-.098.037-.089.171.09h.089l.275-.318.293.179v.372Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.768,6.324l-.129-.048-.003.002-.166.115v.031l-.266.336.266.336v.031l.169.117.129-.048-.079-.052v-.099l.031-.037h.139v-.497h-.138l-.031-.037v-.099l.078-.051Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.485,6.401l.157-.109.095.036-.062.041v.112l.039.046h.132v.468h-.132l-.039.046v.112l.062.041-.095.036-.157-.109v-.029l-.262-.331.262-.331v-.029Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.652,5.876l.107-.099.106.065-.107.099.137.085h-.3l-.258.243-.082-.087.25-.236v-.16l.147.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.147,5.833l.107-.099.106.065-.107.099.137.085h-.299l-.258.243-.082-.087.25-.236v-.16l.146.09ZM7.688,6.162l.107-.099.105.065-.107.099.137.085h-.298l-.258.243-.082-.087.251-.236v-.16l.145.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,5.387h.27l.141.136h.275l.203.106-.047.116-.181-.095h-.08l-.278.322-.303-.187v-.398Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76,5.795l-.096.089.08.05.096-.089-.08-.05ZM7.52,5.811v.141l-.245.231.063.066.251-.237h.254l-.323-.201h0ZM7.256,5.751l-.096.089.08.05.096-.089-.08-.05ZM7.015,5.768v.141l-.245.231.063.066.251-.237h.256l-.325-.201h0Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.797,6.08l-.096.089.08.05.096-.089-.08-.05ZM7.557,6.097v.141l-.245.231.063.066.251-.237h.255s-.324-.201-.324-.201ZM6.307,5.401h.257l.141.136h.277l.189.098-.036.089-.171-.09h-.089l-.275.318-.293-.179s0-.372,0-.372Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.652,7.645l.107.099.106-.065-.107-.099.137-.085h-.3l-.258-.243-.082.087.25.236v.16l.147-.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.147,7.689l.107.099.106-.065-.107-.099.137-.085h-.299l-.258-.243-.082.087.25.236v.16l.146-.09ZM7.688,7.36l.107.099.105-.065-.107-.099.137-.085h-.298l-.258-.243-.082.087.251.236v.16l.145-.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,8.135h.27l.141-.136h.275l.203-.106-.047-.116-.181.095h-.08l-.278-.322-.303.186v.399Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76,7.726l-.096-.089.08-.05.096.089-.08.05ZM7.52,7.71v-.141l-.245-.231.063-.066.251.237h.254l-.323.201h0ZM7.256,7.77l-.096-.089.08-.05.096.089-.08.05ZM7.015,7.754v-.141l-.245-.231.063-.066.251.237h.256l-.325.201h0Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.797,7.441l-.096-.089.08-.05.096.089-.08.05ZM7.557,7.425v-.141l-.245-.231.063-.066.251.237h.255s-.324.201-.324.201ZM6.307,8.121h.257l.141-.136h.277l.189-.098-.036-.089-.171.09h-.089l-.275-.318-.293.179s0,.372,0,.372Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.831,6.324l.129-.048.003.002.166.115v.031l.266.336-.266.336v.031l-.169.117-.129-.048.079-.052v-.099l-.031-.037h-.14v-.497h.139l.031-.037v-.099l-.078-.051Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.115,6.401l-.157-.109-.095.036.062.041v.112l-.039.046h-.132v.468h.132l.039.046v.112l-.062.041.095.036.157-.109v-.029l.262-.331-.262-.331v-.029Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54,7.043l-.072-.063v-.03l-.155-.19.155-.189v-.03l.072-.063.13.106h-.075s.111.112.111.112h.254l.199-.156v-.411h.499l.579-.355v-.093l-.089-.059h-.028l-.096.065-.015.048-.075-.103.147-.123h.023l.165-.121h.062l.165.121h.024l.147.123-.075.103-.015-.048-.096-.065h-.029l-.089.059v.093l.579.355h.499v.411l.199.156h.254l.111-.113h-.075s.13-.105.13-.105l.072.063v.03l.155.189-.155.19v.03l-.072.063-.13-.106h.075s-.111-.112-.111-.112h-.254l-.199.156v.411h-.499l-.579.355v.093l.089.059h.028l.096-.065.015-.048.075.103-.147.123h-.022l-.165.121h-.063l-.165-.121h-.024l-.147-.123.076-.103.015.048.096.065h.028l.089-.059v-.093l-.579-.355h-.499v-.411l-.199-.156h-.254l-.111.113h.075s-.13.105-.13.105Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.307,7.911l.063.049-.063.048v-.097h0ZM6.106,7.999h.002l.165.121h.019v-.095l-.087-.066.087-.066v-.178l-.62-.38h-.457v-.382l-.236-.185h-.357l-.09.101-.09-.101h-.105l.145.177v.029l.058.05.092-.072h-.054v-.018l.121-.123h.266l.209.163v.404h.488l.589.362v.109l-.099.066h-.036l-.104-.07-.008-.026-.051.069.132.111h.021ZM4.532,6.674l.071.08h-.141l.07-.08ZM6.293,5.514l-.063.048.063.049v-.097ZM7.997,6.768l.071.08.071-.08h-.142ZM6.492,5.522l-.165-.121h-.02v.095l.087.066-.087.066v.178l.62.38h.458v.382l.236.185h.357l.09-.101.09.101h.106l-.145-.177v-.029l-.058-.05-.092.072h.054v.018l-.121.123h-.267l-.209-.163v-.404h-.488l-.589-.362v-.109l.099-.066h.037l.104.07.008.026.051-.069-.132-.111h-.024Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293,8.008l-.063-.048.063-.048v.096ZM4.603,6.768l-.071.08-.071-.08h.142ZM6.494,7.999h-.002l-.165.121h-.02v-.095l.087-.066-.087-.066v-.178l.62-.38h.458v-.382l.236-.185h.357l.09.101.09-.101h.106l-.145.177v.029l-.058.05-.093-.072h.054v-.018l-.121-.123h-.266l-.209.163v.404h-.488l-.589.362v.109l.099.066h.037l.104-.07.008-.026.051.069-.132.111h-.022ZM8.068,6.674l-.071.08h.141l-.07-.08ZM6.108,5.522l.165-.121h.019v.095l-.087.066.087.066v.178l-.62.38h-.457v.382l-.237.185h-.356l-.09-.101-.09.101h-.105l.145-.177v-.029l.058-.05.092.072h-.054v.018l.121.123h.266l.209-.163v-.404h.488l.589-.362v-.109l-.099-.066h-.036l-.104.07-.008.026-.051-.069.132-.111h.023ZM6.307,5.611l.063-.048-.063-.049v.097Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293,6.768v-.945l-.616.378h-.448v.375l-.228.178h1.305v.945l.616-.378h.448v-.375l.228-.178h-1.305Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.002,6.768l.228.178v.375h.448l.616.378v-.945h1.305l-.228-.178v-.375h-.448l-.616-.378v.945h-1.305Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.637,6.302l-.107-.099-.106.065.107.099-.137.085h.299l.258.243.082-.087-.251-.236v-.16l-.145.09ZM6.962,7.219l.107.099.105-.065-.107-.099.137-.085h-.298l-.258-.243-.082.087.251.236v.16l.145-.09ZM5.637,7.219l-.107.099-.105-.065.107-.099-.137-.085h.299l.258-.243.082.087-.251.236v.16l-.146-.09ZM6.962,6.302l.107-.099.105.065-.107.099.137.085h-.298l-.258.243-.082-.087.251-.236v-.16l.145.09Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.071,7.3l-.096-.089.08-.05.096.089-.08.05ZM6.831,7.284v-.141l-.245-.231.063-.066.251.237h.255l-.324.201ZM5.529,6.221l.096.089-.08.05-.096-.089.08-.05ZM5.769,6.238v.141l.245.231-.063.066-.251-.238h-.255l.324-.2Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.071,6.221l-.096.089.08.05.096-.089-.08-.05ZM6.831,6.238v.141l-.245.231.063.066.251-.237h.255l-.324-.201ZM5.529,7.3l.096-.089-.08-.05-.096.089.08.05ZM5.769,7.284v-.141l.245-.231-.063-.066-.251.237h-.255l.324.201h0Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.962,6.761l-.662.441-.662-.441.662-.441.662.441Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293,6.341l-.618.412h1.251l-.618-.412v.839l.618-.412h-1.252l.618.412v-.839h.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.477,6.912v.121h-.354v-.121h-.229v-.303h.229v-.121h.354v.121h.229v.303h-.229Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.137,6.502v.121h-.229v.13h.385v-.252h-.156ZM6.307,6.754h.385v-.13h-.229v-.121h-.156v.251ZM5.908,6.768v.13h.229v.121h.156v-.252h-.385ZM6.307,7.019h.156v-.121h.229v-.13h-.385v.251h0Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.429,11.787v-.194h.533v-.194h.533v-1.756h-.533v-.194h-.533v-.194h-.533v-.194h-1.192v.194h-.533v.194h-.533v.194h-.533v1.756h.533v.194h.533v.194h.533v.194h1.193v-.194h.532Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.719,9.073v.194h-.534v.194h-.533v.194h-.533v1.728h.533v.194h.533v.194h.533v.194h1.163v-.194h.533v-.194h.533v-.194h.533v-1.728h-.532v-.194h-.533v-.194h-.533v-.194h-1.163ZM5.86,9.215h.881v.194h.533v.194h.533v.194h.533v1.446h-.533v.194h-.533v.194h-.533v.194h-.881v-.194h-.533v-.194h-.534v-.194h-.533v-1.446h.533v-.194h.533v-.194h.534v-.194Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34,11.618v-.194h-.533v-.194h-.533v-1.417h.533v-.194h.533v-.194h.533v-.194h.853v.194h.534v.194h.533v.194h.533v1.417h-.534v.194h-.532v.194h-.533v.194h-.854v-.194h-.533Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.464,9.567l-.138-.104v.2l-.132.084v-.125l-.127.114-.127-.114v.125l-.146-.093v.186l-.118.086v-.114l-.141.102-.141-.102v.114l-.134-.096v.563h-.155v.256h.155v.563l.133-.096v.114l.141-.102.141.102v-.114l.118.086v.186l.147-.093v.125l.127-.114.127.114v-.125l.132.084v.2l.138-.104v.14l.135-.121.135.121v-.14l.124.094v.214l.185-.169v.198l.256-.165.256.165v-.198l.185.169v-.214l.124-.094v.14l.136-.122.135.121v-.14l.138.104v-.2l.132-.084v.125l.127-.114.127.114v-.125l.147.093v-.186l.118-.086v.114l.141-.102.141.102v-.114l.133.096v-.563h.155v-.256h-.154v-.563l-.133.096v-.114l-.141.102-.141-.102v.114l-.118-.085v-.186l-.147.093v-.125l-.127.114-.127-.114v.125l-.132-.084v-.2l-.138.104v-.14l-.136.121-.135-.121v.14l-.124-.094v-.214l-.185.169v-.198l-.256.165-.256-.165v.198l-.185-.169v.214l-.124.094v-.14l-.135.121-.135-.121v.14Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.407,9.954v-.114l.126.092.004-.003.123-.089v.114l.133-.096v1.326l-.133-.096v.114l-.126-.092-.126.092v-.114l-.133.096v-.549h-.156v-.228h.155v-.549l.133.096ZM5.479,9.459l.121.108.121-.108v.137l.138-.104v2.058l-.138-.104v.137l-.121-.109-.121.108v-.137l-.138.104v-2.058l.138.104v-.136ZM7.121,9.459l-.121.109-.121-.108v.137l-.138-.104v2.058l.138-.104v.137l.121-.11.121.108v-.137l.138.104v-2.058l-.138.104v-.136ZM8.193,9.954v-.114l-.126.092-.004-.003-.123-.089v.114l-.133-.096v1.326l.133-.096v.114l.126-.092.126.092v-.114l.133.096v-.549h.155v-.228h-.155v-.549l-.132.096Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.954,9.654l.113.101.113-.101v.119l.146-.093v1.68l-.146-.093v.119l-.113-.101-.113.101v-.119l-.146.093v-1.68l.146.093v-.119ZM6.058,9.461l-.185-.169v2.456l.185-.169v.204l.242-.155.242.155v-.204l.185.169v-2.456l-.185.169v-.204l-.242.155-.242-.155v.204ZM7.646,9.654l-.113.101-.113-.101v.119l-.146-.093v1.68l.146-.093v.119l.113-.101.113.101v-.119l.146.093v-1.68l-.146.093v-.119Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.476,10.279c.016.016.036.025.057.025.022,0,.041-.008.058-.025.051-.051.052-.143.052-.21l-.069.073-.04-.069s-.033.057-.04.069l-.069-.073c-.001.067,0,.159.051.21h0ZM5.032,10.136l-.043-.043v-.085l-.098.091.175.175.175-.175-.098-.091v.085l-.043.043v-.15l.076-.065-.11-.094-.11.094.076.065v.15ZM5.565,9.968l-.043-.043v-.085l-.098.091.175.175.175-.175-.097-.091v.085l-.043.043v-.15l.076-.065-.11-.094-.11.094.076.065v.15Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.534,10.102l.037.065.057-.06c-.002.075-.018.134-.047.163-.013.014-.029.02-.047.02s-.034-.007-.047-.02c-.029-.029-.045-.088-.047-.163l.057.06.037-.065h0ZM5.62,9.811v.191l.071-.071v-.058l.063.058-.154.155-.154-.154.063-.058v.058l.071.071v-.191l-.068-.058.088-.076.088.076-.068.057Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.087,9.979v.191l.071-.071v-.058l.063.058-.154.154-.154-.154.063-.058v.058l.071.071v-.191l-.068-.058.088-.076.088.076-.068.058Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.124,10.279c-.016.016-.036.025-.057.025-.022,0-.041-.008-.057-.025-.051-.051-.052-.143-.052-.21l.069.073.04-.069s.033.057.04.069l.069-.073c0,.067-.002.159-.052.21h0ZM7.568,10.136l.043-.043v-.085l.098.091-.175.175-.175-.175.098-.091v.085l.043.043v-.15l-.076-.065.11-.094.11.094-.076.065v.15ZM7.035,9.968l.043-.043v-.085l.098.091-.176.175-.175-.175.098-.091v.085l.043.043v-.15l-.076-.065.11-.095.11.094-.076.065v.151Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.066,10.102l-.037.065-.057-.06c.002.075.018.134.047.163.013.014.029.02.047.02s.034-.007.047-.02c.029-.029.045-.088.047-.163l-.057.06-.037-.065h0ZM6.98,9.811v.191l-.071-.071v-.058l-.063.058.154.155.154-.154-.063-.058v.058l-.071.071v-.191l.068-.058-.088-.077-.088.076.068.058Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.513,9.979v.191l-.071-.071v-.058l-.063.058.154.154.154-.154-.063-.058v.058l-.071.071v-.191l.068-.058-.088-.076-.088.076.068.058Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.509,10.032l-.057-.079.147-.136-.137-.113v.08l-.057.049v-.145l.129-.095-.234-.173-.234.173.13.095v.145l-.057-.049v-.08l-.137.113.147.136-.057.079h.417Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.118,10.017l.048-.067-.144-.133.101-.083v.056l.086.074v-.183l-.12-.088.21-.155.21.155-.12.088v.183l.086-.074v-.056l.101.083-.144.133.048.067h-.362Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.193,9.593l.107.079.107-.079-.107-.079-.004.003-.103.076Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,9.531l.083.061-.083.062-.083-.061.083-.062Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.476,10.762c.016-.016.036-.025.057-.025.022,0,.041.008.058.025.051.051.052.143.052.21l-.069-.073-.04.069s-.033-.057-.04-.069l-.069.073c-.001-.067,0-.159.051-.21h0ZM5.032,10.905l-.043.043v.085l-.098-.091.175-.175.175.175-.098.091v-.085l-.043-.043v.15l.076.065-.11.094-.11-.094.076-.065v-.15ZM5.565,11.074l-.043.043v.085l-.098-.091.175-.175.175.175-.098.091v-.085l-.043-.043v.15l.076.065-.11.094-.11-.094.076-.065v-.15Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.534,10.94l.037-.065.057.06c-.002-.075-.018-.134-.047-.163-.013-.013-.029-.02-.047-.02s-.034.007-.047.02c-.029.029-.045.088-.047.163l.057-.06.037.065h0ZM5.62,11.23v-.191l.071.071v.058l.063-.058-.154-.155-.154.154.063.058v-.058l.071-.071v.191l-.068.058.088.076.088-.076-.068-.057Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.087,11.062v-.191l.071.071v.058l.063-.058-.154-.154-.154.154.063.058v-.058l.071-.071v.191l-.068.058.088.076.088-.076-.068-.058Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.124,10.762c-.016-.016-.036-.025-.057-.025-.022,0-.041.008-.057.025-.051.051-.052.143-.052.21l.069-.073.04.069s.033-.057.04-.069l.069.073c0-.067-.002-.159-.052-.21h0ZM7.568,10.905l.043.043v.085l.098-.091-.175-.175-.175.175.098.091v-.085l.043-.043v.15l-.076.065.11.094.11-.094-.076-.065v-.15ZM7.035,11.074l.043.043v.085l.098-.091-.176-.176-.175.175.098.091v-.085l.043-.043v.15l-.076.065.11.095.11-.094-.076-.065v-.15Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.066,10.94l-.037-.065-.057.06c.002-.075.018-.134.047-.163.013-.013.029-.02.047-.02s.034.007.047.02c.029.029.045.088.047.163l-.057-.06-.037.065h0ZM6.98,11.23v-.191l-.071.071v.058l-.063-.058.154-.155.154.154-.063.058v-.058l-.071-.071v.191l.068.058-.088.077-.088-.076.068-.058Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.513,11.062v-.191l-.071.071v.058l-.063-.058.154-.154.154.154-.063.058v-.058l-.071-.071v.191l.068.058-.088.076-.088-.076.068-.058Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.509,11.01l-.057.079.147.136-.137.113v-.08l-.057-.049v.145l.129.095-.234.172-.234-.173.13-.095v-.145l-.057.049v.08l-.137-.113.147-.136-.059-.078h.419Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.118,11.024l.048.067-.144.133.101.083v-.056l.086-.073v.183l-.12.088.21.155.21-.155-.12-.088v-.183l.086.073v.056l.101-.083-.144-.133.048-.067h-.362Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.193,11.449l.107-.079.107.079-.107.079-.004-.003-.103-.076Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,11.51l.083-.061-.083-.062-.083.061.083.062Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.197,10.439h-.235v-.094h-.717l-.499-.328h-.892l-.499.328h-.717v.094h-.235v.164h.235v.094h.717l.499.328h.892l.499-.328h.717v-.094h.235s0-.164,0-.164Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.858,10.032l-.5.327h-.706v.094h-.235v.136h.235v.094h.706l.5.328h.885l.498-.328h.708v-.094h.235v-.136h-.236v-.094h-.708l-.498-.327h-.884ZM5.869,10.08h.861l.457.3v.046h.51v.191h-.51v.046l-.457.298h-.861l-.455-.298v-.046h-.513v-.191h.512v-.046l.456-.3Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.727,10.095l.446.293v.052h.511v.163h-.511v.052l-.446.293h-.854l-.446-.293v-.052h-.511v-.163h.511v-.052l.446-.293h.854Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.652,10.687l.193.145.127-.095-.074-.055-.053.04-.045-.034.727-.546h-.148l-.727.545ZM6.073,10.9h.148l.727-.546-.193-.145-.127.095.074.055.053-.04.045.034-.727.547ZM6.379,10.9h.148l-.727-.546.045-.034.053.04.074-.055-.127-.095-.193.145.727.545ZM6.8,10.687l-.045.034-.053-.04-.074.055.127.095.193-.145-.727-.546h-.148l.727.547ZM5.505,10.521l.13.086.13-.086-.13-.086-.13.086Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17,10.521l.13.086.13-.086-.13-.086-.13.086ZM7.094,10.521l-.13.086-.13-.086.13-.086.13.086Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.924,10.687l-.169.127-.103-.078.05-.038.053.04.069-.052-.708-.532h.1l.708.533ZM6.484,10.886h-.1l-.708-.532.169-.127.103.078-.05.038-.053-.04-.069.052.708.531ZM6.216,10.886h-.1l.708-.532-.069-.052-.053.04-.05-.038.103-.078.169.127-.708.533ZM6.384,10.155h.1l-.708.532.069.052.053-.04.05.038-.103.078-.169-.127.708-.533Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.635,10.452l.104.069-.104.069-.104-.069.104-.069ZM6.3,10.452l.104.069-.104.069-.104-.069.104-.069ZM6.965,10.452l-.104.069.104.069.104-.069-.104-.069Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.017,14.139l-.051.072.091.07-.091.07.051.072.106.012.103-.079.256.163v-.135l-.161-.102.161-.102v-.135l-.256.163-.103-.079-.106.01Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.017,13.669l-.051.072.091.07-.091.07.051.072.106.012.103-.079.256.163v-.135l-.161-.102.161-.102v-.135l-.256.163-.103-.079-.106.01ZM4.017,14.892l-.051-.072.091-.07-.091-.07.051-.072.106-.012.103.079.256-.163v.135l-.161.102.161.102v.135l-.256-.163-.103.079-.106-.01ZM8.583,14.139l.051.072-.091.07.091.07-.051.072-.106.012-.103-.079-.256.163v-.135l.161-.102-.161-.102v-.135l.256.163.103-.079.106.01Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.583,13.669l.051.072-.091.07.091.07-.051.072-.106.012-.103-.079-.256.163v-.135l.161-.102-.161-.102v-.135l.256.163.103-.079.106.01ZM8.583,14.892l.051-.072-.091-.07.091-.07-.051-.072-.106-.012-.103.079-.256-.163v.135l.161.102-.161.102v.135l.256-.163.103.079.106-.01ZM7.558,12.858v.195h.142v.086h.139v-.157h-.124v-.124h-.157ZM7.976,13.166v.195h.142v.086h.14v-.157h-.125v-.124h-.157ZM5.042,12.858v.195h-.142v.086h-.139v-.157h.124v-.124h.157ZM7.558,15.703v-.195h.142v-.086h.139v.157h-.124v.124h-.157ZM5.042,15.703v-.195h-.142v-.086h-.139v.157h.124v.124h.157ZM7.976,15.395v-.195h.142v-.086h.14v.157h-.125v.124h-.157ZM4.624,13.166v.195h-.142v.086h-.14v-.157h.124v-.124h.158ZM4.624,15.395v-.195h-.142v-.086h-.14v.157h.124v.124h.158ZM6.825,12.853l-.108-.105-.106.099.093.09-.12.116h.178l.064-.062.064.062h.178l-.12-.116.093-.09-.106-.099c-.038.035-.074.07-.11.105h0ZM6.3,12.853l-.108-.105-.106.099.093.09-.12.116h.178l.064-.062.064.062h.178l-.12-.116.093-.09-.106-.099c-.038.035-.074.07-.11.105ZM5.775,12.853l.108-.105.106.099-.093.09.12.116h-.177l-.064-.062-.064.062h-.178l.12-.116-.093-.09.106-.099c.037.035.073.07.109.105h0ZM6.825,15.708l-.108.105-.106-.099.093-.09-.12-.116h.178l.064.062.064-.062h.178l-.12.116.093.09-.106.099c-.038-.035-.074-.07-.11-.105h0ZM6.3,15.708l-.108.105-.106-.099.093-.09-.12-.116h.178l.063.062.064-.062h.178l-.12.116.093.09-.106.099c-.037-.035-.073-.07-.109-.105ZM5.775,15.708l.108.105.106-.099-.093-.09.12-.116h-.177l-.064.062-.064-.062h-.178l.12.116-.093.09.106.099c.037-.035.073-.07.109-.105h0Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.468,14.391v.101l-.243-.154-.106.082-.094-.011-.039-.056.095-.073-.095-.073.039-.056.094-.011.106.082.243-.154v.101l-.174.11.174.112ZM4.468,13.921v.101l-.243-.154-.106.082-.094-.01-.039-.056.095-.073-.095-.073.039-.056.094-.011.106.082.243-.154v.101l-.174.11.174.111ZM4.468,14.64v-.101l-.243.154-.106-.082-.094.011-.039.056.095.073-.095.073.039.056.094.011.106-.082.243.154v-.101l-.174-.11.174-.112ZM8.132,14.391v.101l.243-.154.106.082.094-.011.039-.056-.095-.073.095-.073-.039-.056-.094-.011-.106.082-.243-.154v.101l.174.11-.174.112ZM8.132,13.921v.101l.243-.154.106.082.094-.011.039-.056-.095-.073.095-.073-.039-.056-.094-.011-.106.082-.243-.154v.101l.174.11-.174.112ZM8.132,14.64v-.101l.243.154.106-.082.094.011.039.056-.095.073.095.073-.039.056-.094.011-.106-.082-.243.154v-.101l.174-.11-.174-.112ZM7.7,12.872v.124h.124v.128h-.11v-.086h-.142v-.167h.128ZM8.119,13.18v.124h.124v.128h-.111v-.086h-.142v-.167h.129ZM4.899,12.872v.124h-.124v.128h.111v-.086h.142v-.167h-.129ZM7.7,15.689v-.124h.124v-.128h-.11v.086h-.142v.167h.128ZM4.899,15.689v-.124h-.124v-.128h.111v.086h.142v.167h-.129ZM8.119,15.381v-.124h.124v-.128h-.111v.086h-.142v.167h.129ZM4.481,13.18v.124h-.124v.128h.111v-.086h.142v-.167h-.129ZM4.481,15.381v-.124h-.124v-.128h.111v.086h.142v.167h-.129ZM6.717,12.768l.109.105.109-.105.085.079-.093.09.105.102h-.137l-.07-.068-.07.068h-.136l.105-.102-.093-.09.086-.079ZM6.191,12.768l.109.105.109-.105.085.079-.092.09.105.102h-.137l-.07-.068-.07.068h-.137l.105-.102-.092-.09.085-.079h0ZM5.883,12.768l-.109.105-.109-.105-.085.079.093.09-.105.102h.137l.07-.068.07.068h.137l-.105-.102.093-.09-.087-.079ZM6.717,15.793l.109-.105.109.105.085-.079-.093-.09.105-.102h-.137l-.07.068-.07-.068h-.136l.105.102-.093.09.086.079ZM6.191,15.793l.109-.105.109.105.085-.079-.092-.09.105-.102h-.137l-.07.068-.07-.068h-.137l.105.102-.092.09.085.079h0ZM5.883,15.793l-.109-.105-.109.105-.085-.079.093-.09-.105-.102h.137l.07.068.07-.068h.137l-.105.102.093.09-.087.079Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.886,15.214v.308h2.828v-.308h.418v-1.868h-.418v-.308h-2.828v.308h-.418v1.868h.418Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.901,13.053v.307h-.418v1.84h.418v.307h2.798v-.307h.419v-1.84h-.418v-.307h-2.799ZM5.081,13.171h2.438v.297l.101.074h.38v1.478h-.382l-.099.072v.298h-2.438v-.297l-.101-.074h-.381v-1.478h.38l.102-.074v-.296h0Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.095,13.185v.272l.367-.272h-.367ZM7.136,13.185l.367.272v-.272h-.367ZM4.615,13.556v.254l.346-.254h-.346ZM7.638,13.556l.348.256v-.256h-.348ZM7.986,14.748l-.348.258h.348v-.258ZM4.615,14.75v.256h.346l-.346-.256ZM5.095,15.104v.27h.365l-.365-.27ZM7.504,15.104l-.365.27h.365s0-.27,0-.27Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.113,13.186l.873.645v.9l-.873.645h-1.626l-.873-.645v-.9l.873-.645h1.626Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.822,14.834l-.1-.116.094-.109-.094-.109.094-.109-.094-.109.094-.109-.094-.109.094-.109-.094-.109.1-.116h2.955l.1.116-.094.109.094.109-.094.109.094.109-.094.109.094.109-.094.109.094.109-.1.116h-2.955ZM6.854,13.327l-.116-.1-.109.094-.109-.094-.109.094-.111-.095-.109.094-.109-.094-.109.094-.109-.094-.116.1v1.908l.116.1.109-.094.109.094.109-.094.109.094.109-.094.109.094.109-.094.109.094.116-.1v-1.907h.002Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.621,13.333l-.102-.088-.102.088v1.895l.102.088.102-.088s0-1.895,0-1.895ZM6.183,13.333l-.102-.088-.102.088v1.895l.102.088.102-.088s0-1.895,0-1.895Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.829,14.82l-.088-.102.088-.102h2.942l.088.102-.088.102h-2.942ZM7.771,14.178l.088.102-.088.102h-2.942l-.088-.102.088-.102h2.942ZM7.771,13.945l.088-.102-.088-.102h-2.942l-.088.102.088.102h2.942Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.839,13.333l-.102-.088-.102.088v1.895l.102.088.102-.088v-1.895ZM5.965,13.333l-.102-.088-.102.088v1.895l.102.088.102-.088v-1.895Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.829,14.601l-.088-.102.088-.102h2.942l.088.102-.088.102h-2.942ZM4.829,14.164l-.088-.102.088-.102h2.942l.088.102-.088.102h-2.942Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.402,15.228l-.102.088-.102-.088v-1.895l.102-.088.102.088s0,1.895,0,1.895Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.288,13.37h-1.983v.157h-.253v1.506h.253v.157h1.99v-.157h.253v-1.506h-.253v-.157h-.007Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32,13.385v.157h-.255v1.478h.255v.157h.208l-.415-.348v-1.096l.415-.348h-.208ZM7.073,13.385l.413.348v1.096l-.413.348h.208v-.157h.252v-1.478h-.252v-.157h-.208Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.551,13.385l-.424.355v1.082c.005.004.42.352.424.355h1.499l.422-.355v-1.082l-.422-.355h-1.499ZM5.572,13.445h1.455l.385.323v1.026l-.385.321h-1.455l-.383-.321v-1.026l.383-.323Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.957,14.81l.065.028.012.076-.082.072.119.115h-.114l-.082-.079-.082.079h-.115l.119-.115-.082-.072.012-.076.065-.028.082.066.004-.004.079-.062ZM6.382,14.81l.065.028.012.076-.082.072.119.115h-.114l-.082-.078-.082.079h-.115l.119-.115-.082-.072.012-.076.065-.028.082.066.004-.004.079-.063ZM6.643,14.81l-.065.028-.012.076.082.072-.119.115h.115l.082-.079.082.079h.115l-.119-.115.082-.072-.012-.076-.065-.028-.082.066-.004-.004-.08-.062ZM5.957,13.751l.065-.028.012-.076-.082-.072.119-.115h-.114l-.082.079-.082-.079h-.115l.119.115-.082.072.012.076.065.028.082-.066.004.004.079.062ZM6.382,13.751l.065-.028.012-.076-.082-.072.119-.115h-.114l-.082.078-.082-.079h-.115l.119.115-.082.072.012.076.065.028.082-.066.004.004.079.063ZM6.643,13.751l-.065-.028-.012-.076.082-.072-.119-.115h.115l.082.079.082-.079h.115l-.119.115.082.072-.012.076-.065.028-.082-.066-.004.004-.08.062ZM7.397,13.873l-.065.054.065.054v.089l-.1-.082-.072.065-.077-.01-.027-.05.066-.066-.066-.066.027-.05c.006,0,.071-.009.077-.01l.072.065.1-.082v.089ZM7.397,14.227l-.065.054.065.054v.089l-.1-.082-.072.065c-.006,0-.071-.009-.077-.01l-.027-.05.066-.066-.066-.066.027-.05c.006,0,.071-.009.077-.01l.072.065.1-.082v.089ZM7.397,14.689l-.065-.054.065-.054v-.089l-.1.082-.072-.065-.077.01-.027.05.066.066-.066.066.027.05c.006,0,.071.009.077.01l.072-.065.1.082v-.089ZM5.203,13.873l.065.054-.065.054v.089l.1-.082.072.065.077-.01.027-.05-.066-.066.066-.066-.027-.05c-.006,0-.071-.009-.077-.01l-.072.065-.1-.082v.089ZM5.203,14.227l.065.054-.065.054v.089l.1-.082.072.065c.006,0,.071-.009.077-.01l.027-.05-.066-.066.066-.066-.027-.05c-.006,0-.071-.009-.077-.01l-.072.065-.1-.082v.089ZM5.203,14.689l.065-.054-.065-.054v-.089l.1.082.072-.065.077.01.027.05-.066.066.066.066-.027.05c-.006,0-.071.009-.077.01l-.072-.065-.1.082v-.089Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.577,13.459s-.353.296-.369.309c.031.026.062.053.094.079.008-.007.069-.062.069-.062l.09.012.035.065-.064.064c.009.009.064.064.064.064l-.035.065-.09.011s-.061-.053-.069-.06l-.099.083v.028c.033.028.065.055.099.083.008-.007.069-.06.069-.06l.09.011.035.065-.064.064c.009.009.064.064.064.064l-.035.067-.09.011s-.061-.055-.069-.062l-.099.083v.03l.099.083c.008-.007.069-.062.069-.062l.09.012.035.065-.064.064.064.064-.035.065-.09.012s-.061-.055-.069-.062c-.031.026-.062.052-.094.078l.369.309h.081l.118-.115-.076-.067.014-.092.079-.034.081.064.079-.064.079.034.016.092-.078.067.115.109.115-.109-.078-.067.014-.092.081-.034.079.064.081-.064.079.034.014.092-.076.067.113.111.115-.111-.076-.067.014-.092.081-.034.079.064.079-.064.081.034.014.092-.076.067.118.115h.079l.369-.309c-.031-.026-.062-.052-.094-.078-.008.007-.067.062-.067.062l-.09-.012-.037-.065.064-.064-.064-.064.037-.065.09-.012s.059.055.067.062l.099-.083v-.03l-.099-.083c-.008.007-.067.062-.067.062l-.09-.011-.037-.067.064-.064-.064-.064.037-.065.09-.011s.059.053.067.06c.033-.027.066-.054.099-.081v-.032l-.099-.081c-.008.007-.067.06-.067.06l-.09-.011-.037-.065.064-.064-.064-.064.037-.065.09-.012s.059.055.067.062c.032-.026.064-.052.095-.078l-.371-.311h-.072l-.118.115.076.067-.014.092-.081.035-.079-.064-.079.064-.081-.035-.014-.092.076-.067-.113-.109-.115.109.076.067-.014.092-.079.035-.081-.064-.079.064-.081-.035-.014-.092.078-.067-.115-.109-.115.109.078.067-.016.092-.079.035-.079-.064-.081.064-.079-.035-.014-.092.076-.067-.12-.115h-.085ZM5.203,14.245v.072l.042-.037-.042-.035Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.876,15.043l-.062.058h.122l-.06-.058ZM6.299,15.043l-.06.058h.122l-.062-.058ZM6.725,15.043l-.062.058h.124l-.062-.058ZM5.812,13.459l.064.06.062-.06h-.126ZM6.238,13.459l.062.06.064-.06h-.126ZM6.663,13.459l.062.06.062-.06h-.124ZM7.396,13.892l-.042.035.042.034v-.069ZM7.396,14.245l-.042.035.042.035v-.07ZM7.396,14.6l-.042.035.042.035v-.07ZM5.203,13.89v.072l.042-.035-.042-.037ZM5.203,14.245v.072l.042-.037-.042-.035ZM5.203,14.598v.072l.042-.035-.042-.037Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.663,14.162v-.126h-.128v-.139h-.471v.139h-.128v.126h-.176v.237h.177v.126h.128v.139h.471v-.139h.128v-.126h.176v-.237h-.177Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293,13.912v.143l-.203.115v.104h-.316v-.097h.177v-.126h.128v-.139h.214ZM6.307,14.65v-.143l.202-.115v-.104h.316v.097h-.176v.126h-.128v.139h-.214Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51,14.273v-.104l-.202-.115v-.143h.214v.139h.128v.126h.177v.097h-.317ZM5.774,14.288h.316v.104l.202.115v.143h-.213v-.139h-.128v-.126h-.177v-.097Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.105,14.288v.096l.188.107v-.203h-.188Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293,14.07l-.188.107v.096h.188v-.203Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.495,14.273v-.096l-.188-.107v.203h.188Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.307,14.491l.188-.107v-.096h-.188v.203Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.588,16.791v.391h-.372v.354h-.377v1.009h.377v.354h.372v.391h1.353l.238.143-.114.069h-.482l-.042-.047h.437l-.123-.124h-.626l.283.295h.588l.2-.12.2.12h.587l.283-.295h-.625l-.123.124h.437l-.042.047h-.482l-.114-.069.238-.143h1.353v-.391h.372v-.354h.377v-1.009h-.377v-.354h-.372v-.391h-1.354l-.238-.143.114-.069h.483l.042.047h-.437l.123.124h.625l-.283-.295h-.587l-.2.12-.2-.12h-.587l-.283.295h.626l.123-.124h-.438l.042-.047h.483l.114.069-.238.143h-1.354Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.654,19.275h1.344v-.39h.371v-.355h.378v-.98h-.378v-.353h-.371v-.39h-1.344l-.558-.337h-.577l-.256.267h.586l.095-.095h-.435l.067-.076h.494l.632.381h1.155v.39h.373v.355h.378v.699h-.379v.355h-.372v.39h-1.155l-.632.38h-.494l-.067-.074h.436l-.095-.095h-.587l.256.267h.577l.558-.339ZM5.897,19.135h-1.155v-.39h-.371v-.355h-.377v-.699h.378v-.355h.371v-.39h1.155l.634-.381h.493l.065.075h-.434l.095.095h.586l-.256-.267h-.577l-.558.337h-1.343v.39h-.373v.353h-.378v.98h.378v.355h.373v.39h1.344l.558.337h.577l.256-.267h-.587l-.095.095h.434l-.067.074h-.492l-.634-.377Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.299,16.72l-.399.24h-1.144v.39h-.37v.355h-.378v.671h.378v.355h.371v.39h1.143l.399.238.399-.238h1.144v-.39h.373v-.355h.378v-.671h-.378v-.355h-.373v-.39h-1.144l-.399-.24ZM6.299,16.819l.376.226h1.085v.39h.373v.353h.376v.503h-.377v.355h-.372v.39h-1.085l-.376.226-.374-.226h-1.084v-.39h-.372v-.355h-.378v-.503h.378v-.353h.373v-.39h1.084l.373-.226Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.745,18.632v.391h-1.074l-.371.223-.371-.223h-1.074v-.391h-.372v-.354h-.377v-.475h.377v-.354h.372v-.391h1.073l.371-.223.372.223h1.073v.391h.372v.354h.377v.475h-.376v.354h-.372Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.996,18.495v.378h.59l-.59-.391v.013ZM4.996,17.586v-.378h.59l-.59.391v-.013ZM7.604,18.495v.378h-.59l.59-.391v.013ZM7.604,17.586v-.378h-.59l.59.391v-.013Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01,18.509l.528.35h-.528v-.35ZM5.01,17.572c.021-.014.492-.327.528-.35h-.528v.35ZM7.59,18.509l-.528.35h.528v-.35ZM7.59,17.572l-.528-.35h.528v.35Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.748,17.937v-.193h-.066l-.316-.198-.004.002-.312.195h-.065v.193h-.149v.207h.148v.193h.066l.316.198.316-.198h.066v-.193h.226v-.207h-.226Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.366,17.563l.289.181h-.577l.288-.181ZM5.655,18.337l-.289.181-.289-.181h.578ZM5.585,17.951v.179h-.36v-.179h.36Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.734,18.144v.179h-.36v-.179h.36ZM5.359,18.144v.179h-.36v-.179h.36ZM5.96,17.951v.179h-.36v-.179h.36ZM5.211,17.951v.179h-.36v-.179h.36ZM5.734,17.758v.179h-.36v-.179h.36ZM5.359,17.758v.179h-.36v-.179h.36Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.112,17.991v.099h-.162v-.099h.162ZM5.26,17.798v.099h-.162v-.099h.162ZM5.635,17.798v.099h-.162v-.099h.162ZM5.486,17.991v.099h-.162v-.099h.162ZM5.861,17.991v.099h-.162v-.099h.162ZM5.635,18.184v.099h-.162v-.099h.162ZM5.26,18.184v.099h-.162v-.099h.162Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.096,18.006h-.131v.069h.131v-.069ZM5.245,17.813h-.131v.069h.131v-.069ZM5.619,17.813h-.131v.069h.131v-.069ZM5.471,18.006h-.131v.069h.131v-.069ZM5.845,18.006h-.131v.069h.131s0-.069,0-.069ZM5.619,18.199h-.131v.069h.131v-.069ZM5.245,18.199h-.131v.069h.131v-.069Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.852,17.937v-.193h.066l.316-.198.004.002.312.195h.066v.193h.149v.207h-.15v.193h-.066l-.316.198-.316-.198h-.065v-.193h-.226v-.207h.226Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.233,17.563l-.289.181h.578l-.289-.181ZM6.944,18.337l.289.181.289-.181h-.578ZM7.014,17.951v.179h.36v-.179h-.36Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.866,18.144v.179h.36v-.179h-.36ZM7.24,18.144v.179h.36v-.179h-.36ZM6.64,17.951v.179h.36v-.179h-.36ZM7.389,17.951v.179h.36v-.179h-.36ZM6.866,17.758v.179h.36v-.179h-.36ZM7.24,17.758v.179h.36v-.179h-.36Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.488,17.991v.099h.162v-.099h-.162ZM7.34,17.798v.099h.162v-.099h-.162ZM6.965,17.798v.099h.162v-.099h-.162ZM7.114,17.991v.099h.162v-.099h-.162ZM6.739,17.991v.099h.162v-.099h-.162ZM6.965,18.184v.099h.162v-.099h-.162ZM7.34,18.184v.099h.162v-.099h-.162Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.503,18.006h.131v.069h-.131v-.069ZM7.355,17.813h.131v.069h-.131v-.069ZM6.98,17.813h.131v.069h-.131v-.069ZM7.129,18.006h.131v.069h-.131v-.069ZM6.754,18.006h.131v.069h-.131v-.069ZM6.98,18.199h.131v.069h-.131v-.069ZM7.355,18.199h.131v.069h-.131v-.069Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.682,17.614v.193h-.066l-.316.198-.004-.002-.312-.195h-.066v-.193h-.187v-.207h.187v-.193h.066l.316-.198.316.198h.066v.193h.187v.207h-.187Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,17.988l.289-.181h-.578l.289.181ZM6.589,17.214l-.289-.181-.289.181h.578Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.667,17.407v-.179h-.36v.179h.36ZM6.293,17.407v-.179h-.36v.179h.36ZM6.855,17.6v-.179h-.36v.179h.36ZM6.48,17.6v-.179h-.36v.179h.36ZM6.105,17.6v-.179h-.36v.179h.36ZM6.667,17.793v-.179h-.36v.179h.36ZM6.293,17.793v-.179h-.36v.179h.36Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.194,17.268v.099h-.162v-.099h.162ZM6.568,17.268v.099h-.162v-.099h.162ZM6.006,17.461v.099h-.162v-.099h.162ZM6.381,17.461v.099h-.162v-.099h.162ZM6.755,17.461v.099h-.161v-.099h.161ZM6.194,17.654v.099h-.162v-.099h.162ZM6.568,17.654v.099h-.162v-.099h.162Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.178,17.283h-.131v.069h.131v-.069ZM6.553,17.283h-.131v.069h.131v-.069ZM5.991,17.476h-.131v.069h.131v-.069ZM6.366,17.476h-.132v.069h.131v-.069h0ZM6.74,17.476h-.131v.069h.131v-.069ZM6.178,17.669h-.131v.069h.131v-.069ZM6.553,17.669h-.131v.069h.131v-.069Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.682,18.674v.193h-.066l-.316.197-.004-.002-.312-.195h-.066v-.193h-.187v-.207h.187v-.193h.066l.316-.198.316.198h.066v.193h.187v.207h-.187Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,19.048l.289-.181h-.578l.289.181ZM6.589,18.274l-.289-.181-.289.181h.578Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.667,18.467v-.179h-.36v.179h.36ZM6.293,18.467v-.179h-.36v.179h.36ZM6.855,18.66v-.179h-.36v.179h.36ZM6.48,18.66v-.179h-.36v.179h.36ZM6.105,18.66v-.179h-.36v.179h.36ZM6.667,18.853v-.179h-.36v.179h.36ZM6.293,18.853v-.179h-.36v.179h.36Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.194,18.328v.099h-.162v-.099h.162ZM6.568,18.328v.099h-.162v-.099h.162ZM6.006,18.521v.099h-.162v-.099h.162ZM6.381,18.521v.099h-.162v-.099h.162ZM6.755,18.521v.099h-.161v-.099h.161ZM6.194,18.714v.099h-.162v-.099h.162ZM6.568,18.714v.099h-.162v-.099h.162Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.178,18.343h-.131v.069h.131v-.069ZM6.553,18.343h-.131v.069h.131v-.069ZM5.991,18.536h-.131v.069h.131v-.069ZM6.366,18.536h-.132v.069h.131v-.069h0ZM6.74,18.536h-.131v.069h.131v-.069ZM6.178,18.729h-.131v.069h.131v-.069ZM6.553,18.729h-.131v.069h.131v-.069Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.256,20.979l1.402-.754h1.285l1.402.754v1.243l-1.402.754h-1.285l-1.402-.754v-1.243Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.662,20.239l-1.391.749v1.225l1.391.749h1.276l1.391-.749v-1.225l-1.391-.749h-1.276ZM5.687,20.339h1.227l1.317.708v1.107l-1.317.708h-1.228l-1.317-.708v-1.107l1.318-.708Z",
    style: {
      fill: "#00843d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.307,21.593v1.255h.603l1.306-.703v-.537h-1.923v-1.255h-.603l-1.306.703v.537h1.923Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293,21.593v1.255h-.603l-1.306-.703v-.537h1.924v-1.255h.602l1.306.703v.537h-1.923Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.417,22.778v-.363l-.117.074-.117-.074v.363h-.365l.246-.18v-.258l-.375-.238h-.263v-1.002h.262l.375-.238v-.257l-.246-.18h.365v.363l.117-.074.117.074v-.363h.365l-.246.18v.257l.375.238h.262v1.002h-.261l-.375.238v.257l.246.18h-.365Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.432,20.438v.374l-.125-.079v.106l.574.365h.189v.388h.09v-.48h-.253l-.385-.244v-.272l.217-.159h-.307ZM5.441,21.607v.48h.251l.387.245v.272l-.217.159h.307v-.374l.124.079v-.109l-.574-.362h-.188v-.39h-.09Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.862,20.438l.217.159v.272l-.387.244h-.251v.48h.09v-.389h.187l.574-.364v-.108l-.124.079v-.374h-.306ZM7.069,21.607v.39h-.189l-.574.362v.109l.125-.079v.374h.307l-.217-.159v-.272l.385-.245h.252v-.48h-.089Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.545,21.982h.178l.577.366.577-.366h.178v-.764h-.178l-.577-.366-.577.366h-.178v.764Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.699,21.782h.123v-.058h-.092v-.106h.198v.27h-.19v.184h-.391v-.265h.172v.106h-.066v.053h.18v-.101l-.732-.446h-.124v.058h.093v.106h-.198v-.27h.19v-.184h.391v.265h-.172v-.106h.067v-.053h-.18v.101l.731.446ZM6.633,21.336v-.101h-.18v.053h.067v.106h-.173v-.265h.391v.184h.19v.27h-.198v-.106h.093v-.058h-.124l-.732.446v.101h.18v-.053h-.066v-.106h.172v.265h-.391v-.184h-.19v-.27h.198v.106h-.093v.058h.123l.733-.446Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.647,21.857v.124h-.209v-.082h.067v-.077h-.144v.236h.362v-.184h.19v-.242h-.17v.077h.093v.087h-.141l-.742-.452v-.124h.209v.082h-.067v.077h.143v-.236h-.362v.184h-.19v.242h.169v-.077h-.092v-.087h.141l.743.452ZM6.695,21.405h.141v.087h-.092v.077h.169v-.242h-.19v-.184h-.362v.236h.143v-.077h-.066v-.082h.209v.124l-.742.452h-.142v-.087h.093v-.077h-.17v.242h.19v.184h.362v-.236h-.143v.077h.067v.082h-.209v-.124l.742-.452Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.935,21.663v.392h-.167v-.138h-.168v.138h-.167v-.392h.167v.138h.168v-.138h.167ZM7.338,22.184v.392h-.167v-.138h-.168v.138h-.167v-.392h.167v.138h.168v-.138h.167ZM7.935,21.537v-.392h-.167v.138h-.168v-.138h-.167v.392h.167v-.138h.168v.138h.167ZM4.665,21.663v.392h.167v-.138h.168v.138h.167v-.392h-.167v.138h-.168v-.138h-.167ZM4.665,21.537v-.392h.167v.138h.168v-.138h.167v.392h-.167v-.138h-.168v.138h-.167ZM7.338,21.017v-.392h-.167v.138h-.168v-.138h-.167v.392h.167v-.138h.168v.138h.167ZM5.262,22.184v.392h.167v-.138h.168v.138h.167v-.392h-.167v.138h-.168v-.138h-.167ZM5.262,21.017v-.392h.167v.138h.168v-.138h.167v.392h-.167v-.138h-.168v.138h-.167ZM7.437,20.742v.298h.553l-.553-.298ZM5.163,22.458v-.298h-.554l.554.298ZM5.163,20.742v.298h-.554l.554-.298ZM7.437,22.458v-.298h.553l-.553.298Z",
    style: {
      fill: "#383739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.782,21.902v.138h.138v-.364h-.138v.138h-.197v-.138h-.138v.364h.138v-.138h.197ZM7.185,22.423v.138h.138v-.363h-.138v.138h-.197v-.138h-.138v.363h.138v-.138h.197ZM7.782,21.298v-.138h.138v.364h-.138v-.138h-.197v.138h-.138v-.364h.138v.138h.197ZM4.818,21.902v.138h-.139v-.364h.138v.138h.197v-.138h.138v.364h-.138v-.138h-.196ZM4.818,21.298v-.138h-.139v.364h.138v-.138h.197v.138h.138v-.364h-.138v.138h-.196ZM7.185,20.778v-.138h.138v.363h-.138v-.138h-.197v.138h-.138v-.363h.138v.138h.197ZM5.415,22.423v.138h-.139v-.363h.138v.138h.197v-.138h.139v.363h-.139v-.138h-.196ZM5.415,20.778v-.138h-.139v.363h.138v-.138h.197v.138h.139v-.363h-.139v.138h-.196Z",
    style: {
      fill: "#d22630"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.452,20.767v.26h.482l-.482-.26ZM4.666,22.175l.482.26v-.26h-.482Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.148,20.767l-.482.26h.482v-.26ZM7.452,22.175v.26l.482-.26h-.482Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.563,22.694c-.027.114-.117.199-.138.317-.043-.123-.083-.226-.053-.36.021-.096.102-.165.111-.263.088.079.107.192.08.306ZM8.586,23.17c-.075.102-.179.181-.293.234.023-.09-.02-.157-.067-.229-.057-.086-.084-.17-.038-.269.022.051.05.094.084.138.05.068.083.129.091.217.058-.043.084-.107.115-.17.047-.089.124-.164.211-.212-.024.101-.042.206-.103.291h0ZM8.166,23.476c.016.057.03.113.027.173.049-.053.115-.093.174-.136.08-.064.173-.11.238-.192-.01.121-.061.219-.16.293-.104.078-.229.119-.331.201.015-.11-.025-.198-.06-.299-.029-.096-.001-.194.065-.268,0,.081.024.151.047.228h0ZM7.933,23.847c-.022.083-.081.151-.122.225.11-.034.207-.094.306-.15.118-.064.247-.105.354-.191-.053.197-.186.312-.379.37-.132.04-.244.02-.404.085.018-.109.051-.226.102-.324.04-.071.084-.141.109-.219.036.066.053.131.034.204ZM7.529,24.149c-.037.065-.089.12-.15.162.156.01.282-.089.434-.093.094-.003.183.027.279.018-.114.077-.233.144-.371.162-.18.023-.346-.022-.545-.004.093-.065.139-.153.197-.247.075-.118.146-.202.293-.221-.059.066-.093.147-.137.223h0ZM6.974,24.408c.275.047.539.107.819.11-.314.11-.611.129-.922.016-.168-.061-.298-.094-.425-.085-.186.013-.412.087-.662.351l-.098-.079c.359-.319.828-.391,1.288-.313h0Z",
    style: {
      fill: "#ffc72c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/TM.c4e1af9d8ad4a9effa247406779b67b4.svg";
export { ForwardRef as ReactComponent };